import axios from 'axios';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CONFIG } from 'variables/config';
import LeadrsLogo from 'components/icons/LeadrsLogo';
import { saveReferralCode } from 'utils/referral';
import './GuessAccess.css';

const loadingMessages = [
    'Chargement de votre compte invité',
    'Préparation de votre espace de travail',
    'Configuration de vos accès',
    'Initialisation de votre session',
    'Derniers ajustements en cours'
];

const GuessAccess = () => {
    const params = useParams();
    const [messageIndex, setMessageIndex] = useState(0);

    const handleSubmit = (e: any) => {
        axios
            .post(`${CONFIG.apiUrl}/auth/guest`, { referal: params.id })
            .then((res) => {
                localStorage.setItem('token', res.data.token);
                localStorage.setItem('user-type', 'buyer');
                if (res.data.token.length > 10) {
                   setTimeout(() => {
                    window.location.href = '/';
                    }, 3000);
                }
            })
            .catch(() => {});
    };

    useEffect(() => {
        if (params.id) {
            saveReferralCode(params.id);
            handleSubmit(params.id);
        }
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setMessageIndex((prev) => (prev + 1) % loadingMessages.length);
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="fixed inset-0 w-screen h-screen flex items-center justify-center z-[9999] bg-leadrs-yellow-soft">
            <div className="flex flex-col items-center justify-center gap-8">
                <LeadrsLogo
                    size={48}
                    iconBg="#1D1A01"
                    iconRing="#FFF4AA"
                    textColor="#1D1A01"
                />

                <div className="h-8 flex items-center justify-center">
                    <p
                        key={messageIndex}
                        className="loading-text font-geist text-base font-medium text-center text-leadrs-yellow-focus/70"
                    >
                        {loadingMessages[messageIndex]}
                    </p>
                </div>

                <div className="flex gap-2">
                    {[0, 1, 2].map((i) => (
                        <div
                            key={i}
                            className="loading-dot"
                            style={{ animationDelay: `${i * 0.2}s` }}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default GuessAccess;
